import { ContextProviderNode } from '@decisions/server/DecisionsFramework/Design/Properties';
import { getKeyFromPath } from 'components/property-editors/utils/ProviderNodeUtils';
import { MappingColumn } from '../MappingColumn';
import { MappingPanelType } from '../MappingEditorStore';
import {
  useMappingEditorStore,
  getStepSearch,
  getStepFilter,
  getStepTitle,
  getStepPanelPosition,
} from '../MappingEditorStore';
import { StepMappingRow } from '../StepMappingRow';
// import './StepMappingColumn.less';

export interface IStepMappingColumnProps {
  nodes: ContextProviderNode[];
  className?: string;
}

/**
 * Renders step data side of mapping editor.
 *
 * It will dispatch some actions to the mapping editor, but primarily, editors will interact with
 * the ContextProviderService / PropertyEditorService at the root via PropertyEditorContext
 *
 * Copyright (c) 2021 Decisions All Rights Reserved
 */
export function StepMappingColumn({ className, nodes }: IStepMappingColumnProps) {
  const filter = useMappingEditorStore(getStepFilter);
  const search = useMappingEditorStore(getStepSearch);
  const title = useMappingEditorStore(getStepTitle);
  const position = useMappingEditorStore(getStepPanelPosition);

  return (
    <MappingColumn
      className={className}
      position={position}
      title={title}
      filter={filter}
      search={search}
      side={MappingPanelType.STEP}
    >
      {nodes.map(node => {
        const nodeName = node.Node.Name;
        const nodePath = [nodeName];
        return <StepMappingRow key={getKeyFromPath([], node)} contextNode={node} path={nodePath} />;
      })}
    </MappingColumn>
  );
}
